export interface createCompanyMemberArgs {
  id: number
  name: string
  position: string
  introduction?: string
  profile_img_url: string
  created_at: string
}

export class CompanyMember {
  id: number
  name: string
  position: string
  introduction?: string
  profileImgPath: string
  createdAt: string

  constructor(args: createCompanyMemberArgs) {
    this.id = args.id
    this.name = args.name
    this.position = args.position
    this.introduction = args.introduction
    this.profileImgPath = args.profile_img_url
    this.createdAt = args.created_at
  }
}
